module.exports = __webpack_public_path__ + "img/2024shnh-2.18efdc3f.jpg";